import { useState } from "react";
import apiService from "../Services/apiService";
import Terms from "../../src/PopModal/Terms"; 
import PopSendEmail from "../Components/PopSendEmail";
import {useNotification} from "../notifications/useNotification";
import {useLoading} from "../Context/LoadingContext";
type Props = {
  setHasUserClient: (data: boolean) => void;
};
const BranchesOnMap = ({ setHasUserClient }: Props) => { 
      const { addNotification,notifications }= useNotification();
      const {
    showLoader,
    hideLoader,
    isSaudiMobile
  } = useLoading();
  const [clientInfoTemp, setclientInfoTemp] = useState<any>(null);
  const [showTerms, setShowTerms] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [isShowOtp, setIsShowOtp] = useState(false);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [rtnotp, setRtnOtp] = useState("");
  const [errMobile, setErrMobile] = useState("");
  const [errOtp, setErrOtp] = useState("");
  const [errIsAgree, setErrIsAgree] = useState("");
  const [errheader, seterrheader] = useState("");
  const [isSuccess, setIssuccess] = useState(false);
  const [isRegisteredAccount, setIsRegisteredAccount] = useState(false);
  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (validateForm()) {
      vertifyMobile();
    } else {
      seterrheader("راجع مدخلات الحقول");
    }
  };
  const vertifyMobile = async () => {
    showLoader();
    const result = await apiService.fetchData("api/VertifyClientMobile", {
      Mobile: mobile,
      Name: "",
      Kind: "Port",
    }); 
    if (result.isOk === true) {
      setRtnOtp(result?.data.otp);
      setIsShowOtp(true);
      localStorage.setItem("user-module", "1");
      const userObj = {
        username: result?.data.displayName,
        email: "",
        mobile: mobile,
        pass: "",
        kind: 1,
        id: result?.data.id,
      };
      setclientInfoTemp(userObj);
      setIssuccess(true);
      seterrheader(result?.errAr);
      addNotification({
            title: "نجاح",
            message:String( result?.errAr),
            type: "success"
          });
      hideLoader();
    } else {
      setIssuccess(false); 
       addNotification({
            title: "فشل",
            message:String( result?.errAr),
            type: "error"
          });
      localStorage.removeItem("clienttoken");
      localStorage.removeItem("user-client"); // Set to an empty array if no valid data
      hideLoader();
      setclientInfoTemp(null);
    }
  }; 

  const validateForm = () => {
    let isValidate = true;

    if (mobile.trim() === "") {
      isValidate = false;
      setErrMobile("إدخل رقم الجوال  ");
    } else {
      if (isSaudiMobile(mobile.trim()) !== true) {
        isValidate = false;
        setErrMobile("صيغة رقم الجوال غير صحيح");
      } else {
        setErrMobile("");
      }
    }
    if (agreed === false) {
      isValidate = false;
      setErrIsAgree("الرجاء الموافقة على الشروط والاحكام");
    } else {
      setErrIsAgree("");
    }
    return isValidate;
  };
  const validateOtpForm = () => {
    let isValidate = true;
    if (otp.trim() === "") {
      isValidate = false;
      setErrOtp("إدخل رمز ال OTP");
    } else {
      setErrOtp("");
    }
    return isValidate;
  };
  const checkOtp = () => {
    if (validateOtpForm()) {
      if (otp.trim() === rtnotp) {
        localStorage.setItem("user-client", clientInfoTemp);
        setHasUserClient(true);
      } else {
        localStorage.setItem("user-client", "");
        seterrheader("رمز ال otp المدخل غير صحيح");
        setIssuccess(false);
      }
    } else {
      seterrheader("إدخل رمز ال otp");
    }
  };
 
  return (
    <>
      
      <form method="post">
        {showTerms && (
          <Terms
            setShowTerms={setShowTerms}
            setAgreed={setAgreed}
            agreed={agreed}
          />
        )}
        <div
          className="fixed inset-0 z-[50] bg-on-background/40 backdrop-blur-md flex items-center justify-center p-4"
          id="otp-overlay"
        >
          <div
            className="bg-surface w-full max-w-md rounded-2xl shadow-2xl border border-outline-variant/20 overflow-hidden"
            dir="rtl"
          >
            <div className="bg-[#006193] p-6 text-center">
              <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="material-symbols-outlined text-white text-3xl">
                  verified_user
                </span>
              </div>
              <h2 className="text-white font-headline-md text-headline-md m-0">
                التحقق من الهوية
              </h2>
              <p className="text-white/80 font-body-sm mt-2">
                الرجاء إدخال رقم الجوال لتلقي رمز التحقق
              </p>
            </div>
          
          <div
  dir="rtl"
  className="mx-2 mt-3 flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-right shadow-sm"
>
  <span className="material-symbols-outlined mt-0.5 text-2xl text-amber-600">
    info
  </span>

  <div>
    <h2 className="font-semibold text-amber-900">
      ملاحظة
    </h2>

    <p className="mt-1 text-sm leading-6 text-amber-800">
      أنت مسجل بالخدمة. أدخل رقم جوالك للوصول إلى الخدمة واذا كنت لست مسجل بالخدمة يمكنك إرسال طلب بالنقر على الزر اسفل.
    </p>
  </div>
</div>

            
            <div className="p-6 flex flex-col gap-5">
              <div className="flex flex-col gap-2">
                {errheader !== "" ? (
                  isSuccess ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        padding: "12px 16px",
                        marginTop: "12px",
                        backgroundColor: "#f0fdf4",
                        border: "1px solid #bbf7d0",
                        borderRadius: "8px",
                        color: "#15803d",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "1.5",
                        boxShadow: "0 2px 6px rgba(21, 128, 61, 0.08)",
                      }}
                    >
                      <span style={{ fontSize: "18px" }}>✓</span>
                      <span> {errheader}!</span>
                    </div>
                  ) : (
                    <div
                      style={{
                        marginTop: "6px",
                        padding: "6px 10px",
                        color: "#dc2626",
                        backgroundColor: "#fef2f2",
                        borderRadius: "6px",
                        fontSize: "13px",
                        fontWeight: 500,
                      }}
                    >
                      <span style={{ fontSize: "18px" }}>⚠️</span> {errheader}
                    </div>
                  )
                ) : (
                  ""
                )}

                <label className="font-label-md text-on-surface">
                     إدخال رقم الجوال لتلقي رمز التحقق
             
                </label>
                <div className="flex gap-2">
                  <input
                    className="flex-1 bg-surface-container-highest/50 border border-outline-variant/50 rounded-lg px-4 py-3 text-body-md focus:outline-none focus:border-[#006193] transition-colors"
                    placeholder="05x xxx xxxx"
                    onChange={(e) => setMobile(e.target.value)}
                    type="tel"
                    maxLength={12}
                  />
                  {errMobile !== "" ? (
                    <span
                      style={{
                        color: "red",
                        fontWeight: "bold",
                        fontSize: "12px",
                      }}
                    >
                      {errMobile}
                    </span>
                  ) : (
                    ""
                  )}
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="bg-primary text-on-primary px-4 py-3 rounded-lg font-label-md hover:bg-primary/90 transition-colors whitespace-nowrap"
                  >
                    إرسال الرمز
                  </button>
                </div>
              </div>
              <div className="flex items-center gap-3 mt-2">
                <input
                  type="checkbox"
                  id="terms-checkbox"
                  className="w-5 h-5 rounded border-outline-variant/50 accent-[#006193] cursor-pointer"
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                />
                <label
                  htmlFor="terms-checkbox"
                  className="font-body-sm text-on-surface-variant cursor-pointer"
                >
                  أقر بأنني قرأت وأوافق على
                  <a
                    onClick={() => setShowTerms(true)}
                    className="text-[#006193] font-label-md hover:underline"
                  >
                    الشروط والأحكام
                  </a>
                </label>
                {errIsAgree !== "" ? (
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "12px",
                    }}
                  >
                    {errIsAgree}
                  </span>
                ) : (
                  ""
                )}
              </div>

              {isShowOtp ? (
                <>
                  <div className="flex flex-col gap-2">
                    <label className="font-label-md text-on-surface">
                      رمز التحقق (OTP)
                    </label>
                    <input
                      className="w-full bg-surface-container-highest/50 border border-outline-variant/50 rounded-lg px-4 py-3 text-body-md focus:outline-none focus:border-[#006193] transition-colors text-center tracking-[1em] text-lg font-medium"
                      placeholder="••••"
                      maxLength={4}
                      onChange={(e) => setOtp(e.target.value)}
                      type="text"
                    />
                    {errOtp !== "" ? (
                      <span
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {errOtp}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <button
                    type="button"
                    onClick={checkOtp}
                    className="w-full bg-[#006193] text-white font-label-md py-3.5 rounded-lg shadow-md hover:bg-[#006193]/90 hover:shadow-lg transition-all mt-2"
                    id="verify-otp-btn"
                  >
                    تحقق
                  </button>
                </>
              ) : (
                ""
              )}
                 <hr/>
                 
              <button
                type="button"
                onClick={() => setIsRegisteredAccount(true)}
                className="px-8 h-13 py-3 rounded-xl bg-vibrant-orange hover:bg-secondary-container text-on-primary font-bold text-label-md shadow-lg shadow-vibrant-orange/25 hover:shadow-xl transition-all flex items-center justify-center gap-3 group"
               
             > 
                  إرسال طلب للتسجيل بالمنصة
              </button>
            </div>
           
                  {isRegisteredAccount && ( <PopSendEmail  setIsRegisteredAccount={setIsRegisteredAccount}/>)}
  
          </div>
        </div>
      </form>
    </>
  );
};
export default BranchesOnMap;
